module.exports = __webpack_public_path__ + "static/idleon-bdcbcd4e0b9baba2a3f13393066b7104.webp";